// ⚠️ 레거시 — 구 구독 상세 다이얼로그. /subscribe 에서만 쓰이고 진입점이 없다.
// 표시 역할은 PassInfoDialog 의 subscription 모드가 이미 대체했으므로 이 컴포넌트는 부활시키지 않는다.
// store/pass.ts 의 IMappedPassProduct 가 아직 살아있는 이유가 여기(:22 Pick<..., 'expiredAt'>)이고,
// 이 파일이 지워지면 그 타입도 함께 정리할 수 있다.
import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  span.MuiTypography-root {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  padding: 28px 0;\n\n  li {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr 3.5fr;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ScrollBody } from "@/components/Coupons/AdditionalCouponContents";
import SimpleDialog from "@/components/Coupons/SimpleDialog";
import Icon from "@/components/icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
import AnchorDrawer from "@/components/modal/AnchorDrawer";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Divider, styled as muiStyled, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";
import { PassCategory } from "src/api/membership";
import styled from "styled-components";
import { getPassScope } from "../getPassScope";
export const SubscribeDialog = (param)=>{
    let { open , onClose , footer , contentInfo , withCloseIcon =true , children  } = param;
    const { isMobile  } = useWindowDimensions();
    if (!contentInfo) return null;
    if (isMobile) return /*#__PURE__*/ _jsxs(AnchorDrawer, {
        anchor: "bottom",
        open: open,
        onClose: ()=>{
            onClose();
            //mx-140
            mixpanelEvent("Close ui", {
                Type: "딤클릭해서 닫기",
                Position: "".concat(contentInfo.category, " detail popup")
            });
        },
        children: [
            /*#__PURE__*/ _jsxs(AnchorDrawer.Contents, {
                children: [
                    /*#__PURE__*/ _jsxs(AnchorDrawer.Title, {
                        children: [
                            contentInfo.title,
                            withCloseIcon && /*#__PURE__*/ _jsx(ButtonBox, {
                                onClick: ()=>{
                                    onClose();
                                    //mx-140
                                    mixpanelEvent("Close ui", {
                                        Type: "닫기버튼",
                                        Position: "".concat(contentInfo.category, " detail popup")
                                    });
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: Close,
                                    size: Sizes.medium
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(InfoHeader, {
                        subscribeInfo: contentInfo
                    }),
                    /*#__PURE__*/ _jsx(ScrollBody, {
                        children: /*#__PURE__*/ _jsx(InfoBody, {
                            subscribeInfo: contentInfo
                        })
                    })
                ]
            }),
            footer
        ]
    });
    return /*#__PURE__*/ _jsx(SimpleDialog, {
        open: open,
        onClose: ()=>{
            onClose();
            //mx-140
            mixpanelEvent("Close ui", {
                Type: "닫기버튼",
                Position: "".concat(contentInfo.category, " detail popup")
            });
        },
        scroll: "paper",
        title: contentInfo.title,
        subParagraph: /*#__PURE__*/ _jsx(InfoHeader, {
            subscribeInfo: contentInfo
        }),
        footer: footer,
        children: /*#__PURE__*/ _jsx(InfoBody, {
            subscribeInfo: contentInfo
        })
    });
};
const InfoHeader = (param)=>{
    let { subscribeInfo  } = param;
    const theme = useTheme();
    const { availableCount , category  } = subscribeInfo;
    const isExpertSubscribe = useMemo(()=>{
        return category === PassCategory.ExpertSubscription;
    }, [
        category
    ]);
    return /*#__PURE__*/ _jsxs(SubParagraphBox, {
        children: [
            subscribeInfo.expiredAt && subscribeInfo.category.includes("expert") ? /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                color: "mint.400",
                children: "남은 문제 수 : ".concat(numberFormatter(subscribeInfo.availableCount), "개")
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "regular16",
                sx: {
                    color: theme.palette.grey[500]
                },
                children: isExpertSubscribe ? "총 사용 가능 문제 수 : ".concat(numberFormatter(availableCount), "개/30일마다") : /*#__PURE__*/ _jsx(Typography, {
                    component: "span",
                    variant: "subtitle1",
                    color: "secondary.main",
                    children: "사용범위 내 무제한"
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "regular16",
                sx: {
                    color: theme.palette.grey[500]
                },
                children: "사용 기간 : 구독 해지시까지 사용가능"
            })
        ]
    });
};
const InfoBody = (param)=>{
    let { subscribeInfo  } = param;
    const descriptionList = useMemo(()=>{
        if (!subscribeInfo.description) return [];
        return subscribeInfo.description.split("\n");
    }, [
        subscribeInfo
    ]);
    return /*#__PURE__*/ _jsxs(ContentBody, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                sx: (theme)=>({
                        color: theme.palette.grey[50],
                        borderStyle: "thin"
                    })
            }),
            /*#__PURE__*/ _jsxs(ContentGridBox, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "semibold16",
                        children: "이용권 사용범위"
                    }),
                    getPassScope(subscribeInfo).map((scope, idx)=>/*#__PURE__*/ _jsxs(GridRow, {
                            children: [
                                /*#__PURE__*/ _jsx(PrefixText, {
                                    variant: "regular16",
                                    children: scope.type
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "regular16",
                                    children: scope.value
                                })
                            ]
                        }, "scope-" + idx))
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                sx: (theme)=>({
                        color: theme.palette.grey[50],
                        borderStyle: "thin"
                    })
            }),
            /*#__PURE__*/ _jsxs(ContentGridBox, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "semibold16",
                        children: "이용권 상세정보"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        children: descriptionList.map((des, idx)=>/*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: des
                                })
                            }, "description-" + idx))
                    })
                ]
            })
        ]
    });
};
const SubParagraphBox = styled.div.withConfig({
    componentId: "sc-aacd9318-0"
})(_templateObject());
const ContentBody = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        "span.MuiTypography-root": {
            padding: 0
        },
        "& .MuiDialogContent-root": {
            padding: "0 28px"
        }
    };
});
const ContentGridBox = styled.div.withConfig({
    componentId: "sc-aacd9318-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_500);
const GridRow = styled.div.withConfig({
    componentId: "sc-aacd9318-2"
})(_templateObject2());
const PrefixText = styled(Typography).withConfig({
    componentId: "sc-aacd9318-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_gray_300;
});
const ButtonBox = muiStyled("button")({
    all: "unset",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    padding: "0"
});
